cb.define(['common/common_VM.Extend.js'], function(common) {
	//var _util = require('../../../helpers/util');

	var ST_st_storecheckplanlist_VM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},

		init: function(viewmodel) {
			// 参数：是否生单
			var checkInventorySheetGenerate = false;

			let gridModel = viewmodel.getGridModel();
			//作废
			viewmodel.on('invalidSCPlan', function(args) {
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: args.cSvcUrl,
						method: 'POST'
					}
				});

				var datas = {
					storecheckplan: viewmodel.getGridModel().getRow(args.params.index).id
				}
				var params = {
					billnum: "st_storecheckplanlist",
					data: JSON.stringify(datas)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					cb.utils.alert('操作成功', 'success');

					if(viewmodel.get('btnInvalidSCPlan')) {
						viewmodel.get('btnInvalidSCPlan').setVisible(false);
					}
					viewmodel.execute('refresh');
				});
			});

			//联查其他出库单
			viewmodel.on('queryothout', function(args) {
				var selectRow = viewmodel.getGridModel().getData()[args.params.index];
				var originid = selectRow.id;
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: args.cSvcUrl,
						method: args.cHttpMethod
					}
				});
				var params = {
					action: 'queryothout',
					billnum: 'st_storecheckplan',
					data: JSON.stringify(originid)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					if(result != undefined) {
						// cb.utils.alert('操作成功', 'success');
						// viewmodel.execute('refresh');
						var params = {
							mode: 'edit',
							readOnly: true,
							id: JSON.parse(result).id
						};
						var data = {
							billtype: 'voucher',
							billno: JSON.parse(result).billno,
							params: params
						};
						cb.loader.runCommandLine('bill', data, viewmodel);
					}

				});
			});
			//联查其他入库单
			viewmodel.on('queryothin', function(args) {
				var selectRow = viewmodel.getGridModel().getData()[args.params.index];
				var originid = selectRow.id;
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: args.cSvcUrl,
						method: args.cHttpMethod
					}
				});
				var params = {
					action: 'queryothin',
					billnum: 'st_storecheckplan',
					data: JSON.stringify(originid)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					if(result != undefined) {
						// cb.utils.alert('操作成功', 'success');
						// viewmodel.execute('refresh');
						var params = {
							mode: 'edit',
							readOnly: true,
							id: JSON.parse(result).id
						};
						var data = {
							billtype: 'voucher',
							billno: JSON.parse(result).billno,
							params: params
						};
						cb.loader.runCommandLine('bill', data, viewmodel);
					}

				});
			});

			//编辑
			viewmodel.on('beforeEdit', function(args) {
				var rowIndex = args.params.params.index;
				var currentRow = viewmodel.getGridModel().getRow(rowIndex);

				var storecheckplanstatus = currentRow.status;
				//如果未复核并且没有下有单据，那么允许编辑，否则不允许编辑
				if(storecheckplanstatus != null && storecheckplanstatus != undefined && storecheckplanstatus !== '' && storecheckplanstatus == '0') {
					var params = {
						storecheckplan: currentRow.id
					};
					var existSCReality = cb.rest.DynamicProxy.create({
						settle: {
							url: '/billingretail/existSCReality',
							method: 'POST'
						}
					});

					var promise = new cb.promise();

					existSCReality.settle(params, (err, result) => {
						if(err) {
							cb.utils.alert(err.message, 'error');
						}

						if(result === undefined || result == null || result === '') {
							cb.utils.alert("查询实盘单异常！", 'error');
						}

						if(result === true) {
							cb.utils.alert("已产生下游实盘单的计划不允许编辑！");
						} else {
							promise.resolve();
						}
					});

					return promise;
				} else {
					cb.utils.alert("已审核的计划不允许编辑！");
					return false;
				}
			});

			//删除
			viewmodel.on('beforeBatchdelete', function(args) {
				debugger
				var rowIndex = args.params.params.index;
				var currentRow = viewmodel.getGridModel().getRow(rowIndex);

				var storecheckplanstatus = currentRow.status;
				//如果未复核并且没有下有单据，那么允许删除，否则不允许删除
				if(storecheckplanstatus != null && storecheckplanstatus != undefined && storecheckplanstatus !== '' && storecheckplanstatus == '0') {
					var params = {
						storecheckplan: currentRow.id
					};
					var existSCReality = cb.rest.DynamicProxy.create({
						settle: {
							url: '/billingretail/existSCReality',
							method: 'POST'
						}
					});

					var promise = new cb.promise();

					existSCReality.settle(params, (err, result) => {
						if(err) {
							cb.utils.alert(err.message, 'error');
						}

						if(result === undefined || result == null || result === '') {
							cb.utils.alert("查询实盘单异常！", 'error');
						}

						if(result === true) {
							cb.utils.alert("已产生下游实盘单的计划不允许删除！");
						} else {
							promise.resolve();
						}
					});

					return promise;
				} else {
					cb.utils.alert("已审核的计划不允许删除！");
					return false;
				}
			});

			gridModel.on('beforeSetActionsState', function(args) {
				// ====== 查询参数：是否升单 ======
				var queryOptionProxy = cb.rest.DynamicProxy.create({
					settle: {
						url: '/option/getOptionsByParams',
						method: 'POST',
						options: {
							async: false
						}
					}
				});

				var params = {
					optionId: 'business_option',
					name: 'checkInventorySheetGenerate',
					groupCode: 'bo0102'
				};

				var data = queryOptionProxy.settle(params);
				var err = data.error,
					result = data.result;
				if(err) {
					return;
				}

				if(result === undefined) {
					return;
				}

				if(result.length > 0) {
					checkInventorySheetGenerate = result[0].value;
				} else {
					checkInventorySheetGenerate = false;
				}

				var gridModel = viewmodel.getGridModel();

				for(var i = 0; i < args.length; i++) {
					var selectRow = gridModel.getData()[i];
					var curStatus = selectRow.status;
					var row = args[i];

					//未复核状态（status = 0）下   作废、编辑、删除按钮可见  联查不可见
					if(curStatus == 0) {
						if(row.btnInvalidSCPlan) {
							row.btnInvalidSCPlan.visible = true;
						}
						if(row.btnEdit) {
							row.btnEdit.visible = true;
						}
						if(row.btnDelete) {
							row.btnDelete.visible = true;
						}
						if(row.btnQueryOthOut) {
							row.btnQueryOthOut.visible = false;
						}
						if(row.btnQueryOthIn) {
							row.btnQueryOthIn.visible = false;
						}
					} else if(curStatus == 1) { //已复核     作废、编辑、删除按钮不可见  联查可见
						if(row.btnInvalidSCPlan) {
							row.btnInvalidSCPlan.visible = false;
						}
						if(row.btnEdit) {
							row.btnEdit.visible = false;
						}
						if(row.btnDelete) {
							row.btnDelete.visible = false;
						}

						if(checkInventorySheetGenerate) {
							if(row.btnQueryOthOut) {
								row.btnQueryOthOut.visible = true;
							}
							if(row.btnQueryOthIn) {
								row.btnQueryOthIn.visible = true;
							}
						} else {
							if(row.btnQueryOthOut) {
								row.btnQueryOthOut.visible = false;
							}
							if(row.btnQueryOthIn) {
								row.btnQueryOthIn.visible = false;
							}
						}
					} else { //已作废     作废、编辑、删除、联查按钮不可见
						if(row.btnInvalidSCPlan) {
							row.btnInvalidSCPlan.visible = false;
						}
						if(row.btnEdit) {
							row.btnEdit.visible = false;
						}
						if(row.btnDelete) {
							row.btnDelete.visible = false;
						}
						if(row.btnQueryOthOut) {
							row.btnQueryOthOut.visible = false;
						}
						if(row.btnQueryOthIn) {
							row.btnQueryOthIn.visible = false;
						}
					}
				}
			});

			//			gridModel.on('afterSetDataSource', () => {
			//				const rows = gridModel.getRows();
			//				const actions = gridModel.getCache('actions');
			//				const actionsStates = [];
			//				rows.forEach(data => {
			//					var storecheckplanstatus = data.status;
			//					const actionState = {};
			//					actions.forEach(action => {
			//						if(storecheckplanstatus != null && storecheckplanstatus != undefined && storecheckplanstatus !== '' && storecheckplanstatus == 0) {
			//							//未复核状态（status = 0）下
			//
			//							//作废、编辑、删除按钮可见
			//							if(action.cItemName == "btnInvalidSCPlan" || action.cItemName == "btnEdit" || action.cItemName == "btnDelete") {
			//								actionState[action.cItemName] = {
			//									visible: true
			//								};
			//							}
			//							//联查按钮不可见
			//							if(action.cItemName == "btnQueryOthOut" || action.cItemName == "btnQueryOthIn") {
			//								actionState[action.cItemName] = {
			//									visible: false
			//								};
			//							}
			//						} else if(storecheckplanstatus != null && storecheckplanstatus != undefined && storecheckplanstatus !== '' && storecheckplanstatus == 1) {
			//							//已复核
			//							//作废、编辑、删除按钮不可见
			//							if(action.cItemName == "btnInvalidSCPlan" || action.cItemName == "btnEdit" || action.cItemName == "btnDelete") {
			//								actionState[action.cItemName] = {
			//									visible: false
			//								};
			//							}
			//							//联查按钮可见
			//							if(action.cItemName == "btnQueryOthOut" || action.cItemName == "btnQueryOthIn") {
			//								if(checkInventorySheetGenerate) {
			//									actionState[action.cItemName] = {
			//										visible: true
			//									};
			//								}
			//							}
			//						} else if(storecheckplanstatus != null && storecheckplanstatus != undefined && storecheckplanstatus !== '' && storecheckplanstatus == 2) {
			//							//已作废
			//							//作废、编辑、删除、联查按钮不可见
			//							if(action.cItemName == "btnInvalidSCPlan" || action.cItemName == "btnEdit" || action.cItemName == "btnDelete" || action.cItemName == "btnQueryOthOut" || action.cItemName == "btnQueryOthIn") {
			//								actionState[action.cItemName] = {
			//									visible: false
			//								};
			//							}
			//						}
			//					});
			//					actionsStates.push(actionState);
			//				});
			//				gridModel.setActionsState(actionsStates);
			//				return false;
			//			});
		}
	};

	try {
		module.exports = ST_st_storecheckplanlist_VM_Extend;
	} catch(error) {

	}
	return ST_st_storecheckplanlist_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storecheckplanlist_VM.Extend.js